import { Component } from '@angular/core';
import { TGFormControlQuestionDirective } from '../form-control-question';

@Component({
  selector: 'tgf-form-radio-group-question',
  templateUrl: './form-radio-group-question.component.html',
  styleUrls: ['./form-radio-group-question.component.scss']
})
export class FormRadioGroupQuestionComponent extends TGFormControlQuestionDirective {

  onChange(value: any) {
    this.setFormControlValue(value);
    this.changeDetectorRef.detectChanges();
  }

  setFormControlValue(value: any) {
    this.form.get(this.questionModel.controlName)?.setValue(value);
    this.form.get(this.questionModel.controlName)?.markAsTouched();
  }

  onCommentChange(event: any) {
    this.questionModel.comment = event.target.value;
  }

  getChoiceItemText(text: any) {
    if (typeof text === 'function') {
      return text();
    } else {
      return text;
    }
  }

  /*
  isOtherSelected(): boolean {
    return this.question.isOtherSelected;
  }

  getItemClass(item: ItemValue): string {
    return this.question.getItemClass(item);
  }

  isItemSelected(item: ItemValue): boolean {
    return this.question.value === item.value;
  }

  isItemEnabled(item: ItemValue): boolean {
    return this.question.getItemEnabled(item);
  }*/
}
